import { render } from "./GlobalDefaultMargin.vue?vue&type=template&id=3d124be2&scoped=true"
import script from "./GlobalDefaultMargin.vue?vue&type=script&lang=js"
export * from "./GlobalDefaultMargin.vue?vue&type=script&lang=js"

import "./GlobalDefaultMargin.vue?vue&type=style&index=0&id=3d124be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d124be2"]])

export default __exports__